export const _data = state => state?.assignments?.data
export const _data_results = state => state?.assignments?.data?.results
export const _newsletters = state =>
    state?.assignments?.newsletterData?.assignment_list
export const _isLoading = state => state?.assignments?.isLoading
